<template>
  <PrescriptionInfoPage :config="config" />
</template>

<script>
import PrescriptionInfoPage from '@/components/smallComponents/PrescriptionInfoPage.vue'

export default {
  components: { PrescriptionInfoPage },
  data() {
    return {
      config: {
        pageTitle: '通用方信息',
        useInfoTitle: '通用方使用信息',
        showSymptoms: false,
        submitRouteMode1: '/GeneralPrescriptionResult',
        btnTextMode1: '提交通用方信息',
        showGanZhiLabel: false,
        supportMode: false,
        showMainTabCard: true,
        
      },
    }
  },
}
</script>
<style scoped>
</style>
    